import * as types from './actionTypes';

const initialState = {
  sourceList: null,
  sourceDetails: null,
  createSourceSuccess: false,
  statusUpdateSuccess: false,
  sourceError: null,
};

export const sourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SOURCE_LIST:
      return {
        ...state,
        sourceList: action.payload,
      };
    case types.SET_SOURCE_DETAILS:
      return {
        ...state,
        sourceDetails: action.payload,
      };
    case types.CREATE_SOURCE_SUCCESS:
      return {
        ...state,
        createSourceSuccess: action.payload,
        sourceError: null,
      };
    case types.CREATE_SOURCE_FAILURE:
      return {
        ...state,
        sourceError: action.payload,
      };
    case types.CLEAR_SOURCE_ERROR:
      return {
        ...state,
        sourceError: null,
      };
    case types.UPDATE_SOURCE_STATUS_SUCCESS: {
      const { id, status } = action.payload;
      const sources = state.sourceList?.sources || [];
      const updatedSources = sources.map((src) => (src?.id === id ? { ...src, status } : src));
      return {
        ...state,
        sourceList: {
          ...state.sourceList,
          sources: updatedSources,
        },
        statusUpdateSuccess: true,
      };
    }
    case types.SET_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        statusUpdateSuccess: action.payload,
      };
    default:
      return state;
  }
};
